<template lang="pug">
  v-container()
    v-row(justify='center')
      v-card(class="pb-8 login-card", width=360)
        v-card-title(class="px-0 pt-0 pb-4")
          Logo(:step="step", @set-step-value="setStepValue")
        v-card-text(class="pb-0 px-8")
          v-row(class="text-center mb-6")
            v-col(cols="12" class="pt-0")
              h2(class="login-card__title mb-2") Вход
              div(class="login-card__subtitle") {{ step === 'phoneNumber' ? 'Введите свой номер телефона' : 'Введите пин-код из смс' }}
          v-form(ref="form", @submit.prevent="step === 'phoneNumber' ? sendPhoneNumber() : checkSmsCode()")
            v-row(no-gutters)
              v-text-field(
                v-if="step === 'phoneNumber'",
                autocomplete="off",
                v-mask="phoneMask",
                autofocus,
                :rules="phoneRules",
                v-model="phoneNumber",
                label="Номер телефона",
                placeholder="(555) 12-34-56",
                color="#5218BB",
                outlined,
                validate-on-blur)
            v-row(no-gutters)
              v-text-field(
                v-if="step === 'codeNumber'",
                autocomplete="off",
                v-mask="pinMask",
                type="password",
                v-model="pin",
                label="Код из смс",
                color="#5218BB",
                outlined,
                validate-on-blur,
                hide-details,
                class="mb-6")
            v-row(v-if="phoneNumber && step === 'codeNumber'" justify="center" class="mb-6")
              a(class="login-card__link" @click.prevent="sendPhoneNumber()") Запросить код еще раз
            v-row(justify="center" class="mt-4")
              v-btn(
                type="submit",
                large,
                :loading="loading",
                class="px-8",
                color="#FFDC26") {{ step === 'phoneNumber' ? 'Далее' : 'Войти' }}
</template>

<script lang="js">
import { mask } from 'vue-the-mask'
export default {
  name: 'Login',
  components: { Logo: () => import('@/components/Login/Logo.vue') },
  directives: {
    mask
  },
  data: () => ({
    phoneNumber: '',
    pin: null,
    sessionId: null,
    step: 'phoneNumber',
    phoneMask: '+996(###)##-##-##',
    pinMask: '####',
    phoneRules: [
      v => !!v || 'Необходимо ввести номер телефона',
      v => (v && v.length > 15) || 'Введите правильный номер телефона'
    ],
    loading: false
  }),
  methods: {
    sendPhoneNumber() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$store
          .dispatch('SEND_PHONE_NUMBER', this.phoneNumber.replace(/[^0-9]/g, ''))
          .then(sessionId => {
            if (sessionId) {
              this.sessionId = sessionId
              this.step = 'codeNumber'
              this.loading = false
            }
          })
      }
    },
    checkSmsCode() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$store
          .dispatch('CHECK_SMS_CODE', {
            sessionId: this.sessionId,
            code: this.pin
          })
          .then(success => {
            if (success) {
              this.loading = false
              this.$store.dispatch('GET_USER_INFO')
              this.clearData()
              this.$router.push('/')
            }
          })
      }
    },
    setStepValue(value) {
      this.step = value
      this.clearData()
    },
    clearData() {
      this.phoneNumber = null
      this.pin = null
    }
  }
}
</script>

<style scoped lang="scss">
.login-card {
  box-shadow: 0 3px 30px rgba(0, 0, 0, 0.25);
  border-radius: 8px !important;
  &__title {
    font-weight: 700;
    font-size: 32px;
    line-height: 44px;
    color: #333;
  }
  &__subtitle {
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #333;
  }
  &__link {
    font-size: 12px;
    line-height: 16px;
    text-decoration-line: underline;
    color: #3d5afe;
  }
}
</style>
